export const CAMPAING_CHECKED_SETTINGS = 'Campaign//CHECKED_SETTINGS'


// WEBPACK FOOTER //
// ./src/app/campaign/vuex/mutation-types.js